// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__LjMDru","char":"char__r7JCDy","micDotFade":"micDotFade__vv5mu5","compact":"compact__x6r41o"};